module.exports = __webpack_public_path__ + "subsTwo-0682d8e4d7c156d4e5d9bcbd8686c98e.png";